export const CACHE_TTL = 5 * 24 * 60 * 60 * 1000;
const PREFIX = 'syncro:compras-draft:sourcing:v2:';
const cacheKey = (session, unit) => `${PREFIX}${session}:${unit}`;
const valid = (data, unit) => data?.businessUnit === unit && (unit !== 'empaque' || data.supplierSource === 'sales') && ['products', 'suppliers', 'relations', 'quickbooks', 'pending', 'warnings'].every(k => Array.isArray(data[k]));
const pick = (row, fields) => Object.fromEntries(fields.filter(k => row[k] !== undefined).map(k => [k, row[k]]));
const compact = data => ({...data,
    products: data.products.map(p => pick(p, ['_id', 'businessUnit', 'code', 'name', 'category', 'status', 'baseUnit'])),
    suppliers: data.suppliers.map(s => pick(s, ['_id', 'name', 'active', 'country', 'city', 'address', 'contact', 'contacts', 'emails', 'salesCompanyId', 'contactSource', 'phone', 'salesCategories', 'salesProducts', 'salesRestrictedCategories'])),
    quickbooks: data.quickbooks.map(q => pick(q, ['_id'])),
    pending: data.pending.map(q => pick(q, ['_id', 'sku', 'suggestedCode', 'name']))
});

// A digest isolates authenticated sessions without persisting their credentials in cache keys.
export async function cacheSession(storage, cryptoApi) {
    try {
        const session = JSON.parse(storage.getItem('userDetails') || storage.getItem('adminUser') || '{}');
        const token = session?.data?.token || session?.data?.accessToken;
        if (!token || !cryptoApi?.subtle) return null;
        const digest = await cryptoApi.subtle.digest('SHA-256', new TextEncoder().encode(token));
        return Array.from(new Uint8Array(digest), b => b.toString(16).padStart(2, '0')).join('');
    } catch (_) {return null;}
}
export function readSnapshot(storage, session, unit, now = Date.now()) {
    if (!session) return null;
    try {
        const key = cacheKey(session, unit), record = JSON.parse(storage.getItem(key) || 'null');
        if (!record || !valid(record.data, unit) || !Number.isFinite(record.savedAt) || record.savedAt > now || now - record.savedAt >= CACHE_TTL || Date.parse(record.data.loadedAt) !== record.savedAt) {
            storage.removeItem(key); return null;
        }
        return record.data;
    } catch (_) {return null;}
}
export function writeSnapshot(storage, session, data) {
    if (!session || !valid(data, data?.businessUnit) || !Number.isFinite(Date.parse(data.loadedAt))) return false;
    try {
        storage.setItem(cacheKey(session, data.businessUnit), JSON.stringify({savedAt: Date.parse(data.loadedAt), data: compact(data)}));
        return true;
    } catch (_) {return false;}
}
